<div>
  <div class="payment-information">
    <p class="medium-font bold" translate="payment-panel-review-payment_product"></p>

    @if (ngxPurchaseTypeService.isCoursePurchase(options)) {
      <p class="payment-product small-font">
        @if (group.is_plan) {
          <span>{{product.display_name}}</span>
        }
        @if (!group.is_plan) {
          <span>{{group.name}}</span>
        }
      </p>
    }

    @if (ngxPurchaseTypeService.isLicensePurchase(options)) {
      <div class="license-details">
        @if (ngxPurchaseTypeService.isLicenseSeatsPurchase(options)) {
          <div >
            <p class="payment-product small-font">{{licenseDetails.selectedProduct.display_name}}</p>
            <p class="payment-product small-font">
              <span translate="payment-panel-license-details_license-seats-additional-label"></span>: {{licenseDetails.additional_seats}}
            </p>
            @if (licenseDetails.selectedOrg) {
              <p class="payment-product small-font"><span translate="payment-panel-license-details_org-label"></span>: {{licenseDetails.selectedOrg.name}}</p>
            }
            <p class="payment-product small-font">
              {{licenseDetails.licenseName}} - <span translate="{{licenseTypeTranslationKey}}"></span>
            </p>
          </div>
        }
        @if (ngxPurchaseTypeService.isLicenseInitialPurchase(options)) {
          <div >
            <p class="payment-product small-font"><span translate="payment-panel-license-details_title"></span>:</p>
            @if (licenseDetails.selectedOrg) {
              <p class="payment-product small-font"><span translate="payment-panel-license-details_org-label"></span>: {{licenseDetails.selectedOrg.name}}</p>
            }
            <p class="payment-product small-font">
              {{licenseDetails.licenseName}} - <span translate="{{licenseTypeTranslationKey}}"></span>
            </p>
            <p class="payment-product small-font">
              <span translate="payment-panel-license-details_license-student-seats"></span>: {{licenseDetails.seats}}
            </p>
            <p class="payment-product small-font">{{licenseDetails.licenseStartDate | date:'MM/dd/yyyy' }}-{{licenseDetails.licenseEndDate | date:'MM/dd/yyyy' }}</p>
          </div>
        }
        @if (ngxPurchaseTypeService.isLicenseUpgradePurchase(options)) {
          <div>
            <p class="payment-product small-font"><span translate="common_plan"></span>: {{licenseDetails.selectedProduct.display_name}}</p>
            @if (licenseDetails.selectedOrg) {
              <p class="payment-product small-font"><span translate="payment-panel-license-details_org-label"></span>: {{licenseDetails.selectedOrg.name}}</p>
            }
            <p class="payment-product small-font">
              <span translate="payment-panel-license-details_license-student-seats"></span>: {{licenseDetails.seats}}
            </p>
            <p class="payment-product small-font">{{licenseDetails.licenseStartDate | date:'MM/dd/yyyy' }}-{{licenseDetails.licenseEndDate | date:'MM/dd/yyyy' }}</p>
          </div>
        }
      </div>
    }

    <p class="medium-font bold margin-top-30" translate="payment-panel-review-payment_payment-method"></p>
    <p class="payment-method-card small-font fullstory-ignore">XXXX-XXXX-XXXX-{{paymentMethod.details.lastFour}} {{paymentMethod.details.cardType}}</p>

    <p class="medium-font bold margin-top-30" translate="payment-panel-review-payment_billing-address"></p>
    <p class="address-text small-font fullstory-ignore address-line1">{{address.line1}}</p>
    @if (address.line2) {
      <p class="address-text small-font fullstory-ignore address-line2">{{address.line2}}</p>
    }
    <p class="address-text small-font fullstory-ignore address-line3">{{address.city}}, {{address.region}} {{address.postal_code}}</p>
    <p class="address-text small-font fullstory-ignore address-line4">{{address.country}}</p>
  </div>
  <div class="payment-total margin-top-30">
    <div class="pay-row">
      <p translate="payment-panel-review-payment_subtotal"></p>
      <p class="transaction-subtotal">{{ parseTotal(taxEstimate.subtotal) | currency: 'USD' }}</p>
    </div>
    <div class="pay-row">
      <div class="pay-row align-items-center">
        <p translate="payment-panel-review-payment_sales-tax" class="sales-tax-label"></p>
        <a
          target="_blank"
          rel="noopener"
          attr.aria-label="{{ 'payment-panel-review-payment_faq' | translate }}"
          href="https://support.echo360.com/hc/en-us/articles/38604330791565-Sales-Tax-FAQs"
          class="ficon-app-help-circle-outline sales-tax-link-icon"
        ></a>
      </div>
      <p class="tax-amount">{{ parseTotal(taxEstimate.tax_amount) | currency: 'USD' }}</p>
    </div>
    <div class="pay-row">
      <h3 translate="payment-panel-review-payment_total"></h3>
      <h3 class="transaction-total">{{ parseTotal(taxEstimate.total) | currency: 'USD' }}</h3>
    </div>
    @if (shouldShowProrate()) {
      <div class="prorated-note">
        <p
          [innerHTML]="'payment-panel-license-details_prorated-note' | translate: {date: (licenseDetails.licenseEndDate | date: 'shortDate') }">
        </p>
      </div>
    }
  </div>
  <p class="bottom-message" [innerHTML]="'payment-panel-review-payment_bottom-message' | translate"></p>
</div>
